import React, { useEffect } from 'react';
import { useContext as useUsersContext } from 'components/Users/Context';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import useCalendars from 'components/Common/Calendars/Hooks/useCalendars';
import Content from './Content';

export default function Index() {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const calendars = useCalendars();

  useEffect(() => {
    actionsUsers.load(dispatchUsers);
  }, []);

  if (stateUsers.user === null || calendars === null) {
    return (
      <div className="content pt-5 pb-5 member-setting-page">
        <LoadingPlaceholder text="Loading..." />
      </div>
    );
  }

  return (
    <Content calendars={calendars} />
  );
}
